import React from 'react';
import { Col } from 'reactstrap';
import SavedCardForm from 'components/Common/saved-card-form';
import { GoBack } from 'components/Common';

const SavedCard = (props) => {
    const { t } = props
    return (
        <Col xs="12">
            <div className="card-details-panel d-flex justify-content-center">
                <SavedCardForm t={t} from='SC' changePayment={props.changePayment} />
            </div>
            <div className="go-back-site text-center">
                <GoBack t={t} />
            </div>
        </Col>
    )
}

export default SavedCard;